import styled from 'styled-components';

export const S = {
  Feedback: styled.div`
    border-bottom: 1px solid
      ${({ theme }) => theme.pointFeedback.colors.borderFeedback};
    padding: 10px;
  `,
  FeedbackText: styled.span`
    color: ${({ theme }) => theme.pointFeedback.colors.textFeedbackText};
    font-size: 16px;
    white-space: pre-wrap;
    line-height: 1;
  `,
  FeedbackDetail: styled.div`
    display: flex;
    padding-top: 8px;
  `,
  FeedbackAuthor: styled.span`
    color: ${({ theme }) => theme.pointFeedback.colors.textFeedbackAuthor};
    font-size: 13px;
  `,
  FeedbackDate: styled.span`
    padding-left: 10px;
    margin-left: auto;
    color: ${({ theme }) => theme.pointFeedback.colors.textFeedbackDate};
  `,
  CategoryIcon: styled.img.attrs(({ src }) => ({
    src,
  }))`
    width: 24px;
    height: 24px;
    border: 3px solid ${({ theme }) => theme.pointDetails.colors.borderIcon};
    border-radius: 5px;
    margin-top: -5px;
    margin-left: -5px;

    & svg {
      width: 24px;
      height: 24px;
    }

    & svg g {
      fill: ${({ color }) => `#${color}`};
      width: 100%;
      height: 100%;
    }

    & svg path {
      width: 100%;
      height: 100%;
    }
  `
};
